import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React from 'react';

import type { Progress as Props } from './progress.types';

const Progress: React.FC<Props> = ({ currentStep, label, totalSteps }) => (
  <div className="sales-flow-progress">
    <Text className="sales-flow-progress__label" theme={Text.themes.emphasis}>
      {label}
    </Text>
    <div
      aria-label={label}
      aria-valuemax={totalSteps}
      aria-valuemin={1}
      aria-valuenow={currentStep}
      className="sales-flow-progress__track"
      role="progressbar"
    >
      <div
        className="sales-flow-progress__value"
        style={{ width: `${(currentStep / totalSteps) * 100}%` }}
      />
    </div>
  </div>
);

export default Progress;
